import React from "react";
import { PageLayout } from "../../../components/layout";
import { LoadingOverlay, Paper, Tabs, Text } from "@mantine/core";
import { IconFileText, IconShoppingCart } from "@tabler/icons";
import { FundingProgramSupplierLedInformationForm } from "../../../components/funding-program-supplier/information-form";
import { useNavigate, useParams } from "react-router";
import { LbfProgramApi } from "../../../apis";
import useSwr from "swr";
import { LbfProgramData } from "../../../components/funding-program-buyer/information-form";
import { Message } from "../../../utils/message";
import HttpHandler from "../../../utils/http-handler";
import { FundingProgramSupplierLedBusinessList } from "../../../components/funding-program-supplier/business-list";
import { IAuth } from "../../../interfaces/IAuth";
import { useSelector } from "react-redux";

export function FundingProgramSupplierLedEdit() {
  const params = useParams();
  const { id, type, refCode } = params;
  const breadcrumbs = useBreadcrumb();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = React.useState(type || "INFORMATION");
  const [loading, setLoading] = React.useState<boolean>(false);
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);

  const { data, mutate } = useSwr(`/api/program/supplier-led/${params.id}`, async () => await LbfProgramApi.get(id as string));

  const onSubmit = async (value: LbfProgramData, type: boolean) => {
    setLoading(true);
    const event = new Date(value.resolutionDate);
    if (type && !value.businessId) {
      Message.error("Та анкорыг сонгон уу!");
    } else {
      try {
        await LbfProgramApi.update(id as string, {
          name: value?.name,
          resolutionNo: value?.resolutionNo,
          resolutionDate: event.toISOString(),
          description: value?.description,
          sector1Id: value?.sector1Id,
          sector2Id: value?.sector2Id,
          sector3Id: value?.sector3Id,
          businessId: value?.businessId,
          lbfProgramLimit: parseInt(value?.lbfProgramLimit),
          complete: type,
        });

        await mutate();

        if (type) {
          navigate(`/cf/funding-program/SUPPLIER/${refCode}/edit/${id}/BUSINESS`);
          setTabIndex("BUSINESS");
        } else {
          navigate(`/cf/funding-program/SUPPLIER`);
        }
        Message.success("Хөтөлбөрийн амжилттай засварлан хадгалсан!");
      } catch (err) {
        Message.error((err as HttpHandler)?.message!);
      }
    }

    setLoading(false);
  };

  const onTabChange = (_index: string) => {
    navigate(`/cf/funding-program/SUPPLIER/${refCode}/edit/${id}/${_index}`);
    setTabIndex(_index);
  };

  return (
    <PageLayout title="Хөтөлбөр засварлах" subTitle="Уламжлалт зээлийн бүтээгдэхүүн суурьтай санхүүжилтийн хөтөлбөр" breadcrumb={breadcrumbs} extra={[]}>
      <Paper radius="sm" p="md" withBorder>
        <Tabs value={tabIndex} onTabChange={onTabChange}>
          <LoadingOverlay visible={loading} />
          <Tabs.List>
            <Tabs.Tab value="INFORMATION" icon={<IconFileText color={tabIndex === "INFORMATION" ? "#3e166e" : "#44566C"} />}>
              <Text size="sm" weight={500} c="#44566C">
                Үндсэн мэдээлэл
              </Text>
            </Tabs.Tab>

            {(user?.permissions || []).filter((c) => c.module === "LBF" && c.code === "LBF_PROGRAM_SME_MANAGEMENT_SL" && c.isView).length > 0 && (
              <Tabs.Tab value="BUSINESS" icon={<IconShoppingCart color={tabIndex === "BUSINESS" ? "#3e166e" : "#44566C"} />}>
                <Text size="sm" weight={500} c="#44566C">
                  Худалдан авагч бизнес
                </Text>
              </Tabs.Tab>
            )}
          </Tabs.List>
          <Tabs.Panel value="INFORMATION">{data && <FundingProgramSupplierLedInformationForm onSubmit={onSubmit} action={["update", data]} />}</Tabs.Panel>

          {(user?.permissions || []).filter((c) => c.module === "LBF" && c.code === "LBF_PROGRAM_SME_MANAGEMENT_SL" && c.isView).length > 0 && (
            <Tabs.Panel value="BUSINESS">
              {data && (
                <FundingProgramSupplierLedBusinessList
                  data={data}
                  onSuccess={async () => {
                    await mutate();
                  }}
                />
              )}
            </Tabs.Panel>
          )}
        </Tabs>
      </Paper>
    </PageLayout>
  );
}

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Үндсэн",
  },
  {
    label: "Зээл суурьтай санхүүжилт",
  },
  {
    to: "/cf/funding-program/SUPPLIER",
    label: "Supplier-LED хөтөлбөрийн жагсаалт",
  },
  {
    label: "Засварлах",
  },
];
